<template>
  <div class="container">
    <form class="needs-validation" id="page-form" @submit.prevent="validateBeforeSubmit($event, proceed)" data-toggle="validator" novalidate>
      <div class="form-group-container">
        <div class="col-12">
            <h1 class="page-title">Register</h1>
          </div>
        <div class="introduction row">
          <div class="col-12">

          </div>
        </div>
        <div class="col-12 col-lg-12 clear-padding-left" v-if="this.addSuccessful">
          <div class="alert alert-success">
            <p class="">Thank you for registering, a confirmation email has been sent to your email address.</p>
            <p>Please check your junk folder as well as your inbox for this email.</p>
          </div>
        </div>
        
        <div class="col-12 col-lg-12 clear-padding-left" v-if="this.registrationErrors != null && this.registrationErrors.length > 0">
          <div class="alert alert-danger">
            <p class="">{{this.submitMessage}}</p>
            <div v-for="(error, index) in this.registrationErrors" :key="index">
              <p>{{error}}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-10 center-align" v-if="!this.addSuccessful">
          <div v-if="loaded">
            <Textbox id="item.firstname" :errors="this.errors" :value="item.firstname" @update="UPDATE_FIELD" label="Firstname" :lettersOnly="true" />
            <Textbox id="item.lastname" :errors="this.errors" :value="item.lastname" @update="UPDATE_FIELD" label="Lastname" :lettersOnly="true" />
            <Textbox id="item.email" :errors="this.errors" :value="item.email" @update="UPDATE_FIELD" label="Email" />
            <Textbox id="item.contactNo" :errors="this.errors" :value="item.contactNo" @update="UPDATE_FIELD" label="Contact Number" :numbersOnly="true" />
            <Textbox id="item.password" type="password" :errors="this.errors" :value="item.password" @update="UPDATE_FIELD" label="Password" inputType="password" />
            <Textbox id="item.confirmPassword" type="password" :errors="this.errors" :value="item.confirmPassword" @update="UPDATE_FIELD" label="Confirm password" inputType="password" />

            <div class="form-group row button-top-margin">
              <div class="col-12 col-lg-4"></div>
              <div class="col-12 col-lg-8">
                <div class="row">
                  <div class="col-4 col-md-4 login-btns">
                    <button type="submit" class="btn default-btn-color btn-primary">Save</button>
                  </div>
                  <div class="col-4 col-md-4">
                    <router-link class="btn default-btn-color btn-primary" to="/">Cancel</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
/* eslint-disable */
import { UserService } from "@/services/UserServices/UserService";
import Tooltip from "@/components/controls/Tooltip.vue";
import Textbox from "@/components/controls/Textbox.vue";
import Textarea from "@/components/controls/Textarea.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
//import formUpdateMixin from "@/mixins/formUpdateMixin";
import { toastNotificationComputed, toastNotificationMethods, toastNotificationMutations } from "@/state/helpers";

var validations = {
  "item.firstname": FormFieldValidators.generic_required,
  "item.lastname": FormFieldValidators.generic_required,
  "item.email": FormFieldValidators.emailAddress,
  "item.contactNo": FormFieldValidators.phone, 
  "item.password": FormFieldValidators.passwordRegistration,
  "item.confirmPassword": FormFieldValidators.confirmPassword
};

export default {
  name: "Register",
  //mixins: [formUpdateMixin, commonMixin, rbValidator],
  mixins: [commonMixin, rbValidator],
  props: [],
  components: {
    Tooltip,
    Textbox,
    Textarea
  },
  data() {
    return {
      addSuccessful: false,
      loaded: true,
      validations: validations,
      submitMessage: "",
      registrationErrors: [],
      item: {
        firstname: "",
        lastname: "",
        email: "",
        contactNo: "",
        password: "",
        confirmPassword: ""
      }
    };
  },
  methods: {
    ...toastNotificationMethods,
    ...toastNotificationMutations,
    UPDATE_FIELD(key, value) {
      this.setFieldValue(this.item, key, value);
    },
    proceed() {
      this.save();
    },
    async save() {
      var response = await UserService.register(
        JSON.parse(JSON.stringify(this.item))
      );

      console.log("response: ", response);
      if (response.successful) {
        this.submitMessage = "";
        this.addSuccessful = true;
        this.reset(null);

        this.SHOW_TOAST_NOTIFICATION({ message: "Registration successful... ", statusCode: this.notificationStatusCode.success });
        this.scrollToTop("page-form");

        return;

      } else {
        this.registrationErrors = response.errors;
        this.SHOW_TOAST_NOTIFICATION({ message: "Registration failed... ", statusCode: this.notificationStatusCode.error });
        this.scrollToTop("page-form");
        this.submitMessage = response.message;
      }
    },
    reset(val) {
      this.item = {
        firstname: "",
        lastname: "",
        email: "",
        contactNo: "",
        password: "",
        confirmPassword: ""
      };
    }
  },
  computed: {},
  created() {
    setTimeout(() => {
      this.init("page-form", this.validations);
    }, 400);
  },
  mounted() {}
};
</script>

<style scoped>
</style>
